import { render, staticRenderFns } from "./CourseCertificateList.vue?vue&type=template&id=7fc02254&scoped=true&"
import script from "./CourseCertificateList.vue?vue&type=script&lang=js&"
export * from "./CourseCertificateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc02254",
  null
  
)

export default component.exports